module.exports = __webpack_public_path__ + "img/berry.8d0ec2c3.webp";